<template>
  <component
    :is="component.component.name"
    v-for="(component, index) in specificComponents"
    :key="`${keyPrefix}-${index}`"
    :component="component"
  ></component>
</template>

<script lang="ts">
// common
import Separator from '~/components/library/Separator.vue';
import FormContainer from '~/components/library/FormContainer.vue';
import InfoCard from '~/components/theme4/components/InfoCard.vue';
import MeetCard from '~/components/theme4/components/MeetCard.vue';
import LatestProperties from '~/components/theme4/properties/LatestProperties.vue';
import BlogsBox from '~/components/theme4/sidebar/BlogsBox.vue';
import OurGuide from '~/components/theme4/components/OurGuide.vue';
import InfoBox from '~/components/theme4/components/InfoBox.vue';
import FormCard from '~/components/theme4/components/FormCard.vue';
import TeamCard from '~/components/theme4/components/TeamCard.vue';
import ManageCard from '~/components/library/ManageCard.vue';
export default defineNuxtComponent({
  props: {
    specificComponents: {
      required: false,
      default: () => [],
    },

    keyPrefix: {
      required: false,
      type: String,
      default: 'dynamicComponent',
    },
  },

  components: {
    Separator,
    FormContainer,
    InfoCard,
    LatestProperties,
    MeetCard,
    BlogsBox,
    OurGuide,
    ManageCard,
    InfoBox,
    FormCard,
    TeamCard,
  },
});
</script>
